var React = require('react');

function MessageWhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#FFF","stroke":"#FFF","className":"stroke-colored-el fill-colored-el","d":"M1.5 11.264L4.91 9.5H11A1.5 1.5 0 0012.5 8V4A1.5 1.5 0 0011 2.5H3A1.5 1.5 0 001.5 4v7.264z","fillRule":"evenodd"}));
}

MessageWhite.defaultProps = {"width":"14","height":"14"};

module.exports = MessageWhite;

MessageWhite.default = MessageWhite;
